import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { loadManifest, parseKeysFromHash } from "./manifestManager";

/**
 * Re-loads the manifest whenever the client or event key changes.
 */
export function ManifestWatcher() {

  const location = useLocation();
  const lastManifestKey = useRef(null);

  useEffect(() => {
    const { clientKey, eventKey } = parseKeysFromHash();
    const manifestKey = eventKey || clientKey || "home";

    // only reload if context actually changed
    if (manifestKey !== lastManifestKey.current) {
      loadManifest();
      lastManifestKey.current = manifestKey;
    }
  }, [location.pathname, location.hash]);

  return null;
}
